<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Gender</h5>
          </span>
          <span slot="content">
            <doughnut-chart
              :showLegend="true"
              :legendPosition="'bottom'"
              :data="processGenderStats">
            </doughnut-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Gender / Province</h5>
          </span>
          <span slot="content">
            <horizontal-bar-chart
              :stacked="true"
              :data="processGenderProvinceStats">
            </horizontal-bar-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Gender / Population Group</h5>
          </span>
          <span slot="content">
            <bar-chart
              :stacked="true"
              :data="processGenderPopulationGroupStats">
            </bar-chart>
          </span>
        </i-box>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Province</h5>
          </span>
          <span slot="content">
            <doughnut-chart
              :data="processProvinceStats">
            </doughnut-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Province / Age</h5>
          </span>
          <span slot="content">
            <horizontal-bar-chart
              :stacked="true"
              :data="processProvinceAgeStats"></horizontal-bar-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Province / Population Group</h5>
          </span>
          <span slot="content">
            <bar-chart
              :stacked="true"
              :data="processProvincePopulationGroupStats">
            </bar-chart>
          </span>
        </i-box>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Population Group</h5>
          </span>
          <span slot="content">
            <doughnut-chart
              :data="processPopulationGroupStats">
            </doughnut-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Population Group / Age</h5>
          </span>
          <span slot="content">
            <horizontal-bar-chart
              :stacked="true"
              :data="processPopulationGroupAgeStats">
            </horizontal-bar-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Population Group / LSM</h5>
          </span>
          <span slot="content">
            <bar-chart
              :stacked="true"
              :data="processPopulationGroupLsmStats">
            </bar-chart>
          </span>
        </i-box>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Age</h5>
          </span>
          <span slot="content">
            <doughnut-chart
              :data="processAgeStats">
            </doughnut-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Age / LSM</h5>
          </span>
          <span slot="content">
            <horizontal-bar-chart
              :stacked="true"
              :data="processAgeLsmStats">
            </horizontal-bar-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>Age / Gender</h5>
          </span>
          <span slot="content">
            <bar-chart
              :stacked="true"
              :data="processAgeGenderStats">
            </bar-chart>
          </span>
        </i-box>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>LSM</h5>
          </span>
          <span slot="content">
            <doughnut-chart
              :data="processLsmStats">
            </doughnut-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>LSM / Province</h5>
          </span>
          <span slot="content">
            <horizontal-bar-chart
              :stacked="true"
              :data="processLsmProvince">
            </horizontal-bar-chart>
          </span>
        </i-box>
      </div>
      <div class="col-lg-4">
        <i-box>
          <span slot="title">
            <h5>LSM / Gender</h5>
          </span>
          <span slot="content">
            <bar-chart
              :stacked="true"
              :data="processLsmGender">
            </bar-chart>
          </span>
        </i-box>
      </div>
    </div>
  </div>
</template>

<script>
  import IBox from '@/components/common/IBox';

  import BarChart from '@/components/charts/BarChart';
  import HorizontalBarChart from '@/components/charts/HorizontalBarChart';
  import DoughnutChart from '@/components/charts/DoughnutChart';

  export default {
    name: 'AudienceDashboard',
    components: {
      IBox,
      BarChart,
      HorizontalBarChart,
      DoughnutChart,
    },
    computed: {
      processGenderStats() {
        return [
          ['male', 41],
          ['female', 59],
        ];
      },

      processGenderProvinceStats() {
        return [
          ['Eastern Cape', { male: 30, female: 40 }],
          ['Free State', { male: 15, female: 20 }],
          ['Gauteng', { male: 90, female: 95 }],
          ['KwaZulu-Natal', { male: 70, female: 65 }],
          ['Limpopo', { male: 10, female: 10 }],
          ['Mpumalanga', { male: 5, female: 6 }],
          ['North West', { male: 6, female: 7 }],
          ['Northern Cape', { male: 12, female: 19 }],
          ['Western Cape', { male: 20, female: 25 }],
        ];
      },

      processGenderPopulationGroupStats() {
        return [
          ['Asian', { male: 10, female: 12 }],
          ['Black', { male: 30, female: 45 }],
          ['Coloured', { male: 15, female: 14 }],
          ['White', { male: 50, female: 60 }],
        ];
      },

      processProvinceStats() {
        return [
          ['Western Cape', 600],
          ['Northern Cape', 50],
          ['North West', 150],
          ['Mpumalanga', 170],
          ['Limpopo', 70],
          ['KwaZulu-Natal', 200],
          ['Gauteng', 1200],
          ['Free State', 100],
          ['Eastern Cape', 180],
        ];
      },

      processProvincePopulationGroupStats() {
        return [
          ['Asian', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['Black', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['Coloured', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['White', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
        ];
      },

      processProvinceAgeStats() {
        return [
          ['18-25', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['26-32', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['33-45', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['46-55', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['56-65', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['66-74', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
          ['75-150', {
            'Eastern Cape': this.rnd(),
            'Free State': this.rnd(),
            Gauteng: this.rnd(),
            'KwaZulu-Natal': this.rnd(),
            Limpopo: this.rnd(),
            Mpumalanga: this.rnd(),
            'North West': this.rnd(),
            'Northern Cape': this.rnd(),
            'Western Cape': this.rnd(),
          }],
        ];
      },

      processPopulationGroupStats() {
        return [
          ['Asian', this.rnd()],
          ['Black', this.rnd()],
          ['Coloured', this.rnd()],
          ['White', this.rnd()],
        ];
      },

      processPopulationGroupAgeStats() {
        return [
          ['18-25', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['26-32', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['33-45', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['46-55', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['56-65', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['66-74', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['75-150', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
        ];
      },

      processPopulationGroupLsmStats() {
        return [
          ['poor', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['low', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['low mid', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['mid', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['up mid', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
          ['top', {
            Asian: this.rnd(),
            Black: this.rnd(),
            Coloured: this.rnd(),
            White: this.rnd(),
          }],
        ];
      },

      processAgeStats() {
        return [
          ['18-25', 10],
          ['26-32', 50],
          ['33-45', 30],
          ['46-55', 20],
          ['56-65', 10],
          ['66-74', 5],
          ['75-150', 1],
        ];
      },

      processAgeLsmStats() {
        return [
          ['poor', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
          ['low', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
          ['low mid', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
          ['mid', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
          ['up mid', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
          ['top', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
        ];
      },

      processAgeGenderStats() {
        return [
          ['Male', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }],
          ['Female', {
            '18-25': this.rnd(),
            '26-32': this.rnd(),
            '33-45': this.rnd(),
            '46-55': this.rnd(),
            '56-65': this.rnd(),
            '66-74': this.rnd(),
            '75-150': this.rnd(),
          }]];
      },

      processLsmStats() {
        return [
          ['poor', this.rnd()],
          ['low', this.rnd()],
          ['low mid', this.rnd()],
          ['mid', this.rnd()],
          ['up mid', this.rnd()],
          ['top', this.rnd()],
        ];
      },

      processLsmGender() {
        return [
          ['male', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd() }],
          ['female', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd() }],
        ];
      },

      processLsmProvince() {
        return [
          ['Eastern Cape', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['Free State', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['Gauteng', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['KwaZulu-Natal', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['Limpopo', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['Mpumalanga', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['North West', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['Northern Cape', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
          ['Western Cape', {
            poor: this.rnd(),
            low: this.rnd(),
            'low mid': this.rnd(),
            mid: this.rnd(),
            'up mid': this.rnd(),
            top: this.rnd(),
          }],
        ];
      },
    },
    methods: {
      rnd() {
        return Math.floor(Math.random() * 100) + 1;
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// AudienceDashboard.vue?38b91b20